/**
 * @file ResetIcon.tsx
 * @description A React component that renders an SVG reset icon.
 * The icon's color can be customized via the `className` prop.
 */

import React from "react";
import { IconProps } from "../../../types";

const ResetIcon: React.FC<IconProps> = ({ className = "" }) => (
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19.8889 7.05556C18.33 3.76667 14.93 1.5 11 1.5C9.68678 1.5 8.38642 1.75866 7.17317 2.2612C5.95991 2.76375 4.85752 3.50035 3.92893 4.42893C3.00035 5.35752 2.26375 6.45991 1.7612 7.67317C1.25866 8.88642 1 10.1868 1 11.5C1 12.8132 1.25866 14.1136 1.7612 15.3268C2.26375 16.5401 3.00035 17.6425 3.92893 18.5711C4.85752 19.4997 5.95991 20.2362 7.17317 20.7388C8.38642 21.2413 9.68678 21.5 11 21.5C13.6522 21.5 16.1957 20.4464 18.0711 18.5711C18.9663 17.6758 19.6743 16.6283 20.1698 15.4894M21 1.5V8.16667L14.3333 8.16667"
      stroke="currentColor"
      strokeWidth="1.75"
    />
  </svg>
);

export default ResetIcon;
